import { fallbackSkillType, SkillBase } from '../@competentNL/Skills/Skills';
import { transformToSkillBase } from '../@competentNL/Skills/SkillsTransformers';
import { transformToCompetency } from '../Competencies/CompetenciesTransformer';
import {
    AddOrganisationOccupationRequest,
    EditOrganisationOccupationRequest,
    OrganisationOccupation,
    OrganisationOccupationFormData,
    OrganisationOccupationResource,
} from './OrganisationOccupation';

export const transformToOrganisationOccupation = (
    organisationOccupationResource: OrganisationOccupationResource,
): OrganisationOccupation => {
    const escoSkills: SkillBase[] = organisationOccupationResource.skills.map(skill => ({
        type: fallbackSkillType,
        id: skill.id,
        label: skill.label,
    }));

    return {
        id: organisationOccupationResource.id,
        title: organisationOccupationResource.title,
        description: organisationOccupationResource.description,
        escoSkills,
        skills: organisationOccupationResource.cnlSkills.map(transformToSkillBase),
        competencies: organisationOccupationResource.competencies.map(transformToCompetency),
    };
};

export const transformToAddOrganisationOccupationRequest = (
    formData: OrganisationOccupationFormData,
    organisationUuid: string,
): AddOrganisationOccupationRequest => ({
    organisationUuid,
    title: formData.title,
    description: formData.description,
});

export const transformToEditOrganisationOccupationRequest = (
    formData: OrganisationOccupationFormData,
    organisationUuid: string,
): EditOrganisationOccupationRequest => ({
    id: formData.id || '',
    organisationUuid,
    title: formData.title,
    description: formData.description,
    skills: formData.escoSkills,
    cnlSkills: formData.skills,
    competencies: formData.competencies,
});
